<template>
	<div v-loading="loading" element-loading-text="文件生成中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
		<el-divider>静态HTML生成</el-divider>
		<el-form class="text-left" label-position="top">
			<el-form-item label="生成语言" :label-width="formLabelWidth" prop="lngs">
				<el-checkbox-group v-model="createInfo.lngs" @change="lngChange">
					<el-checkbox v-for="(lng, index) in lngs" :key="index" :label="lng.lng">{{ lng.lngtitle }}</el-checkbox>
				</el-checkbox-group>
			</el-form-item>
			<el-form-item label="生成内容" :label-width="formLabelWidth" prop="create_type">
				<el-checkbox-group v-model="createInfo.create_type" @change="typeChange">
					<el-checkbox v-for="(type, index) in create_type" :key="index" :label="type.val">{{ type.label }}</el-checkbox>
				</el-checkbox-group>
			</el-form-item>
			<el-form-item label="生成范围" :label-width="formLabelWidth" prop="site_type">
				<el-checkbox-group v-model="createInfo.site_type" @change="siteChange">
					<el-checkbox v-for="(type, index) in site_type" :key="index" :label="type.val">{{ type.label }}</el-checkbox>
				</el-checkbox-group>
			</el-form-item>
			<el-form-item class="text-center">
				<el-button type="primary" @click="createHtml">生成HTML</el-button>
				<el-button type="default" @click="turnBack()">取消返回</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>
<script>
export default {
	name: 'createHtml',
	data() {
		return {
			loading: false,
			formLabelWidth: '120px',
			lngs: [], //开通的多语言
			create_type: [
				{
					label: '首页HTML',
					val: 1
				},
				{
					label: '分类页HTML',
					val: 2
				},
				{
					label: '内容页',
					val: 3
				},
				// {
				// 	label: '信息发布页',
				// 	val: 4
				// }
			],
			site_type: [
				{
					label: 'PC端',
					val: 'web'
				},
				{
					label: '移动端',
					val: 'wap'
				}
			],
			createInfo: {
				lngs: [], //生成语言
				create_type: [], //生成页
				site_type: [] //生成端
			}
		};
	},
	mounted() {
		this.getLngs();
	},
	methods: {
		// 获取当前启用的语言列表
		getLngs() {
			this.$axios({
				url: this.HOST + '/admin.index/getlngs',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						if (res.data.admin_err == 'admininfo_error') {
							this.$message.error(res.data.msg);
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.lngs = res.data;
					}
				})
				.catch(err => {});
		},
		lngChange(e) {
			console.log(e);
		},
		typeChange(e) {
			console.log(e);
		},
		siteChange(e) {
			console.log(e);
		},
		createHtml() {
			console.log(this.createInfo);
			for (let i in this.createInfo) {
				if (!this.createInfo[i].length) {
					this.$message.error('存在未勾选内容项');
					return false;
				}
			}
			this.$confirm('确认按当前设置生成静态文件？')
				.then(_ => {
					this.loading = true;
					console.log(this.createInfo);
					this.$axios({
						url: this.HOST + '/admin.index/createStaticHtml',
						method: 'post',
						data: {
							adminid: JSON.parse(this.$store.state.user.userInfo).id,
							token: JSON.parse(this.$store.state.user.userInfo).token,
							createInfo:this.createInfo
						}
					})
						.then(res => {
							console.log(res.data);
							this.loading = false;
							if (res.data.status == 0) {
								this.$message.error(res.data.msg);
								if (res.data.admin_err == 'admininfo_error') {
									this.exit().then(res => {
										console.log(res);
										if (res.actionStatus == 1) {
											this.$router.push('/login');
										}
									});
								}
							} else {
								this.$message.success(res.data.msg);
							}
						})
						.catch(err => {});
					
				})
				.catch(fail => {});
		}
	}
};
</script>
<style></style>
